import { VALUE_UNRESOLVED } from '../../Consts/backoffice.const';
import {
  LICENCE_HOLDER_LABEL,
  LICENCE_STATE_LABEL,
  LICENCE_STATE_TONE,
  LicenceHolder,
  LicenceState,
} from '../../Enums/licence-state.enum';
import { PRICE_COMPONENT_LABEL, PriceComponentType } from '../../Enums/price-component-type.enum';
import { LicenceResponse } from '../../Interfaces/api/backoffice/licence.interface';
import { StatusTone } from '../../Modules/Shared/Types/status-tone.type';

export class Licence {
  id = '';
  component_type = '';
  state = '';
  is_half_state = false;
  holder_type = '';
  holder_id: string | null = null;
  holder_name: string | null = null;
  holder_email: string | null = null;
  holder_deleted_at: string | null = null;
  purchased_at: string | null = null;
  assigned_at: string | null = null;
  released_at: string | null = null;
  cancels_at: string | null = null;

  constructor(data: Partial<LicenceResponse> = {}) {
    Object.assign(this, data);
  }

  get componentLabelKey(): string {
    return PRICE_COMPONENT_LABEL[this.component_type as PriceComponentType] ?? this.component_type;
  }

  get effectiveState(): string {
    return this.is_half_state ? LicenceState.HALF_STATE : this.state;
  }

  get stateLabelKey(): string {
    return LICENCE_STATE_LABEL[this.effectiveState] ?? this.effectiveState;
  }

  get stateTone(): StatusTone {
    return LICENCE_STATE_TONE[this.effectiveState] ?? 'neutral';
  }

  get holderLabelKey(): string {
    return LICENCE_HOLDER_LABEL[this.holder_type] ?? this.holder_type;
  }

  get holderDisplay(): string {
    return this.holder_name || this.holder_email || VALUE_UNRESOLVED;
  }

  get holderIsDeleted(): boolean {
    return this.holder_deleted_at !== null;
  }

  get isEnding(): boolean {
    return this.cancels_at !== null;
  }

  get isFree(): boolean {
    return this.holder_type === LicenceHolder.NONE;
  }

  get isCancellable(): boolean {
    return this.isFree && !this.isEnding;
  }

  get isResumable(): boolean {
    return this.isEnding;
  }
}
